'use client';

import useTickedAllSubAccounts from 'src/hooks/useTickedAllSubAccounts';
import SideDrawer from 'src/components/Drawers/BaseDrawers/SideDrawer/SideDrawer';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import { useEffect, useMemo } from 'react';
import { cm } from 'src/utils/classNames';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { useUpdateCurrentSubaccount } from 'src/hooks/velocityActions/user/useUpdateCurrentSubaccount';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import { FocusTrap } from '@headlessui/react';

export default function AccountHotkeySelectionDrawer() {
	const [isOpen, selectedAccountIndex, setDrawerStore] = useDrawersStore(
		(s) => [
			s.accountHotkeySelection.show,
			s.accountHotkeySelection.selectedAccountIndex,
			s.set,
		]
	);
	const subAccounts = useTickedAllSubAccounts();
	const subAccountsOrdered = useMemo(() => {
		return subAccounts.sort((a, b) => {
			// sort by poolId first, then by userId
			if (a.poolId === b.poolId) {
				return a.userId - b.userId;
			}
			return a.poolId - b.poolId;
		});
	}, [subAccounts]);
	const currentAuthority = useVelocityStore(
		(state) => state.wallet.current?.adapter?.publicKey
	);

	const currentUserKey = useVelocityAccountStore((s) => s.currentUserKey);

	useEffect(() => {
		const drawerSelectedUserKey =
			subAccountsOrdered[selectedAccountIndex]?.userKey;

		if (drawerSelectedUserKey !== currentUserKey) {
			const newUserIndex = subAccountsOrdered.findIndex(
				(subAccount) => subAccount.userKey === currentUserKey
			);
			if (newUserIndex !== -1) {
				setDrawerStore((s) => {
					s.accountHotkeySelection.selectedAccountIndex = newUserIndex;
				});
			}
		}
	}, [isOpen, currentUserKey, subAccountsOrdered?.length]);

	const { updateCurrentSubaccount } = useUpdateCurrentSubaccount();

	return (
		<SideDrawer.Container
			drawerName="accountHotkeySelection"
			className="right-xl border-none bg-transparent shadow-none sm:w-[173px] sm:max-w-[173px]"
			onClose={() => {
				const newUserId = subAccountsOrdered[selectedAccountIndex]?.userId;
				if (newUserId && currentAuthority) {
					updateCurrentSubaccount(newUserId, currentAuthority);
				}
			}}
		>
			<FocusTrap>
				<div className="flex flex-col">
					{/** Subaccount Options */}
					<div className="flex w-full flex-col rounded-sm bg-tooltip-bg">
						{subAccountsOrdered.map((subAccount, index) => (
							<div
								key={subAccount.userKey}
								className={cm(
									'flex h-12 flex-row items-center gap-2 rounded-xs p-px',
									index === selectedAccountIndex && 'bg-primary-gradient'
								)}
							>
								<div
									key={subAccount.userKey}
									className="flex h-full w-full flex-col items-center justify-center rounded-xs bg-tooltip-bg text-center text-text-default hover:bg-input-border"
								>
									<span className="typo-label-sm">{subAccount.name}</span>
									<span className="typo-body-xs text-text-secondary">
										D + {index + 1}
									</span>
								</div>
							</div>
						))}
					</div>
				</div>
			</FocusTrap>
		</SideDrawer.Container>
	);
}
